import styled from '@emotion/styled';
import { getColor, GridContainer } from '../../../ui/index.ts';

export const Container = styled(GridContainer)`
  height: 100%;
  background-color: ${getColor('main-background')};
`;
